<template>
<textarea :name="keyIndex"
        class="input-box"
        :class="{ error: isError }"
        v-bind:value="value"
        v-on:input="updateValue($event.target.value)"
        :placeholder="placeHolder"></textarea>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'LayoutTextarea',
  props: {
    keyIndex: {
      type: String,
    },
    value: {
      type: [String, Number],
    },
    placeHolder: {
      type: String,
    },
    regex: {
      type: String,
      default: '',
    },
  },
  computed: {
    isError() {
      if (_.isEmpty(this.regex)) return false;

      const result = new RegExp(this.regex);
      return !result.test(String(this.value).toLowerCase());
    },
  },
  methods: {
    updateValue(value) {
      this.$emit('input', value);
    },
  },
};
</script>

<style lang="scss" scoped>
.input-box {
  width: 500px;
  height: 150px;
  padding-left: 15px;
  outline: none;

  border: rgba(180, 180, 180, 0.4) 1px solid;

  border-radius: 5px;
}

.input-box:hover {
  border: rgba(180, 180, 180, 0.8) 1px solid;
}

.input-box:focus {
  border: rgba(100, 200, 255, 0.8) 1px solid;
  box-shadow: rgba(0, 0, 0, 0.1) 1px 1px 5px 1px;
}

.error {
  color: rgb(159, 85, 80);
  background: rgb(253, 246, 246);
  border: rgb(217, 162, 181) 1px solid;
}
</style>



// WEBPACK FOOTER //
// src/spa/components/LayoutTextarea.vue